// Plan-gating utilities. AI features unlocked for everyone in beta;
// flip CURRENT_PLAN once paid plans go live (read from user/settings).

export const CURRENT_PLAN = "ai"; // "free" | "pro" | "ai"

export function isAIEnabled() {
  return CURRENT_PLAN === "ai";
}

export function planLockReason() {
  if (CURRENT_PLAN === "ai") return null;
  return CURRENT_PLAN === "pro"
    ? "Upgrade to AI Plan to unlock unlimited smart messages."
    : "Upgrade to AI Plan to unlock smart messages, retention nudges and insights.";
}
